import React from 'react';

import { ReactComponent as LogOutIcon } from '@assets/svg/ic-log-out.svg';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const lineBreak = { break: '</br>' };

const LogOutConfirmModal = () => {
  const { t } = useTranslation();
  const { setModalClose } = useModalActions();

  const handleLogout = () => window.location.replace(APP_SSO_URL + 'logout-simple/2');

  return (
    <div className={style.modalLogoutConfirm}>
      <ModalHeader />
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>{t('Log Out')}</div>
        <div className={style.modalBodyIcon}>
          <LogOutIcon />
        </div>
        <div
          className={style.confirmText}
          dangerouslySetInnerHTML={{
            __html: t('Are you sure you {break} want to log out of your account?', lineBreak),
          }}
        />
      </div>
      <div className={style.modalFooter}>
        <Button type="primary" text={t('Log Out')} onClick={handleLogout} />
        <Button type="secondary" text={t('Cancel')} onClick={setModalClose} />
      </div>
    </div>
  );
};

export default LogOutConfirmModal;
